import { useOpen, useBlobUrl } from "../../../../../../../libs/hooks";
import { useWorkflowStore } from "../../../../../store";
import { Chip, Grid } from "@mui/material";
import { OnlyPhoto } from "../../../../../../../libs/shared";

export const SellosArriboVerificadora = ({
  widthFull,
}: {
  widthFull: string;
}) => {
  return (
    <Grid
      container
      justifyContent="flex-start"
      alignContent="flex-start"
      alignItems="flex-start"
      spacing={0}
      sx={{ bgcolor: "white", pt: 1 }}
    >
      <EtiquetaPuerta />
      <EtiquetaPlastico />
      <BotellaRastreo />
      <NumeroRastreoSatelital />
      <Grid item xs={12}>
        <Grid
          container
          spacing={0}
          sx={{
            borderTop: "1px dashed darkgreen",
            pt: 6,
            pb: 2,
            position: "relative",
          }}
        >
          <Chip
            color="success"
            label="ETIQUETAS VENTOLERAS"
            sx={{ borderRadius: 1, position: "absolute", top: 5, left: 14 }}
          />

          <EtiquetaVentoleras1 widthFull={widthFull} />

          <EtiquetaVentoleras2 widthFull={widthFull} />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid
          container
          sx={{
            borderTop: "1px dashed darkgreen",
            pt: 6,
            pb: 2,
            position: "relative",
          }}
        >
          <Chip
            color="success"
            label="ETIQUETAS PANEL EXTERIOR"
            sx={{ borderRadius: 1, position: "absolute", top: 5, left: 14 }}
          />

          <EtiquetaPanelExterior1 widthFull={widthFull} />

          <EtiquetaPanelExterior2 widthFull={widthFull} />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid
          container
          sx={{
            borderTop: "1px dashed darkgreen",
            pt: 6,
            pb: 2,
            position: "relative",
          }}
        >
          <Chip
            color="success"
            label="ETIQUETAS DUCTOS"
            sx={{ borderRadius: 1, position: "absolute", top: 5, left: 14 }}
          />

          <EtiquetaPanelInterior1 widthFull={widthFull} />

          <EtiquetaPanelInterior2 widthFull={widthFull} />

          <EtiquetaPanelInterior3 widthFull={widthFull} />
        </Grid>
      </Grid>
    </Grid>
  );
};

const EtiquetaPuerta = () => {
  const {
    open: openEtiquetaVerificadoraPuerta,
    handleClose: handleCloseEtiquetaVerificadoraPuerta,
    handleOpen: handleOpenEtiquetaVerificadoraPuerta,
  } = useOpen();

  const etiquetaVerificadoraPuertaPhoto = useWorkflowStore(
    (state) => state.etiquetaVerificadoraPuertaPhoto
  );

  const setEtiquetaVerificadoraPuertaPhoto = useWorkflowStore(
    (state) => state.setEtiquetaVerificadoraPuertaPhoto
  );
  const setEtiquetaExporPuertaPhoto = useWorkflowStore(
    (state) => state.setEtiquetaExporPuertaPhoto
  );

  const fotoUrl = useBlobUrl(etiquetaVerificadoraPuertaPhoto);

  return (
    <Grid
      item
      xs={12}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseEtiquetaVerificadoraPuerta}
        handleOpen={handleOpenEtiquetaVerificadoraPuerta}
        label="ETIQUETA PUERTA"
        open={openEtiquetaVerificadoraPuerta}
        setFoto={(lafoto) => {
          setEtiquetaVerificadoraPuertaPhoto(lafoto);
          setEtiquetaExporPuertaPhoto(lafoto);
        }}
        fontSize={12}
        width={240}
      />
    </Grid>
  );
};

const EtiquetaPlastico = () => {
  const {
    open: openPlastico,
    handleClose: handleClosePlastico,
    handleOpen: handleOpenPlastico,
  } = useOpen();

  const plasticoPhoto = useWorkflowStore((state) => state.plasticoPhoto);
  const setPlasticoPhoto = useWorkflowStore((state) => state.setPlasticoPhoto);
  const fotoUrl = useBlobUrl(plasticoPhoto);

  return (
    <Grid
      item
      xs={12}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleClosePlastico}
        handleOpen={handleOpenPlastico}
        label="SELLO PLÁSTICO"
        open={openPlastico}
        setFoto={setPlasticoPhoto}
        width={240}
        fontSize={12}
      />
    </Grid>
  );
};

const BotellaRastreo = () => {
  const {
    open: openBotellaRastreo,
    handleClose: handleCloseBotellaRastreo,
    handleOpen: handleOpenBotellaRastreo,
  } = useOpen();

  const botellaRastreoPhoto = useWorkflowStore(
    (state) => state.botellaRastreoPhoto
  );

  const setBotellaRastreoPhoto = useWorkflowStore(
    (state) => state.setBotellaRastreoPhoto
  );
  const fotoUrl = useBlobUrl(botellaRastreoPhoto);

  return (
    <Grid
      item
      xs={12}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseBotellaRastreo}
        handleOpen={handleOpenBotellaRastreo}
        label="SELLO RASTREO"
        open={openBotellaRastreo}
        setFoto={setBotellaRastreoPhoto}
        width={240}
        fontSize={12}
      />
    </Grid>
  );
};

const NumeroRastreoSatelital = () => {
  const {
    open: openNumRastreo,
    handleClose: handleCloseNumRastreo,
    handleOpen: handleOpenNumRastreo,
  } = useOpen();

  const numRastreoSatelitalPhoto = useWorkflowStore(
    (state) => state.numRastreoSatelitalPhoto
  );

  const setNumRastreoSatelitalPhoto = useWorkflowStore(
    (state) => state.setNumRastreoSatelitalPhoto
  );
  const fotoUrl = useBlobUrl(numRastreoSatelitalPhoto);

  return (
    <Grid
      item
      xs={12}
      sx={{
        mb: 2,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pl: 1.6,
      }}
    >
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseNumRastreo}
        handleOpen={handleOpenNumRastreo}
        label="N° RASTREO"
        open={openNumRastreo}
        setFoto={setNumRastreoSatelitalPhoto}
        width={240}
        fontSize={12}
      />
    </Grid>
  );
};

const EtiquetaVentoleras1 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openEtVent1,
    handleClose: handleCloseEtVent1,
    handleOpen: handleOpenEtVent1,
  } = useOpen();

  const etiquetasVentolerasPhoto1 = useWorkflowStore(
    (state) => state.etiquetasVentolerasPhoto1
  );

  const setEtiquetasVentolerasPhoto1 = useWorkflowStore(
    (state) => state.setEtiquetasVentolerasPhoto1
  );
  const setMacroEtiquetasVentolerasPhoto1 = useWorkflowStore(
    (state) => state.setMacroEtiquetasVentolerasPhoto1
  );
  const fotoUrl = useBlobUrl(etiquetasVentolerasPhoto1);

  return (
    <Grid item xs={5} sx={{ m: 1 }}>
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseEtVent1}
        handleOpen={handleOpenEtVent1}
        label="LADO IZQUIERDO"
        open={openEtVent1}
        setFoto={(lafoto) => {
          setEtiquetasVentolerasPhoto1(lafoto);
          setMacroEtiquetasVentolerasPhoto1(lafoto);
        }}
        width={widthFull === "xs" ? 50 : 130}
        fontSize={widthFull === "xs" ? 8 : 10}
      />
    </Grid>
  );
};

const EtiquetaVentoleras2 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openEtVent2,
    handleClose: handleCloseEtVent2,
    handleOpen: handleOpenEtVent2,
  } = useOpen();

  const etiquetasVentolerasPhoto2 = useWorkflowStore(
    (state) => state.etiquetasVentolerasPhoto2
  );

  const setEtiquetasVentolerasPhoto2 = useWorkflowStore(
    (state) => state.setEtiquetasVentolerasPhoto2
  );
  const setMacroEtiquetasVentolerasPhoto2 = useWorkflowStore(
    (state) => state.setMacroEtiquetasVentolerasPhoto2
  );
  const fotoUrl = useBlobUrl(etiquetasVentolerasPhoto2);

  return (
    <Grid item xs={5} sx={{ m: 1 }}>
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseEtVent2}
        handleOpen={handleOpenEtVent2}
        label="LADO DERECHO"
        open={openEtVent2}
        setFoto={(lafoto) => {
          setEtiquetasVentolerasPhoto2(lafoto);
          setMacroEtiquetasVentolerasPhoto2(lafoto);
        }}
        width={widthFull === "xs" ? 50 : 130}
        fontSize={widthFull === "xs" ? 8 : 10}
      />
    </Grid>
  );
};

const EtiquetaPanelExterior1 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openEtPExt1,
    handleClose: handleCloseEtPExt1,
    handleOpen: handleOpenEtPExt1,
  } = useOpen();

  const etiquetasPanelExteriorPhoto1 = useWorkflowStore(
    (state) => state.etiquetasPanelExteriorPhoto1
  );

  const setEtiquetasPanelExteriorPhoto1 = useWorkflowStore(
    (state) => state.setEtiquetasPanelExteriorPhoto1
  );
  const fotoUrl = useBlobUrl(etiquetasPanelExteriorPhoto1);

  return (
    <Grid item xs={5} sx={{ m: 1 }}>
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseEtPExt1}
        handleOpen={handleOpenEtPExt1}
        label="LADO IZQUIERDO"
        open={openEtPExt1}
        setFoto={setEtiquetasPanelExteriorPhoto1}
        width={widthFull === "xs" ? 50 : 130}
        fontSize={widthFull === "xs" ? 8 : 10}
      />
    </Grid>
  );
};

const EtiquetaPanelExterior2 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openEtPExt2,
    handleClose: handleCloseEtPExt2,
    handleOpen: handleOpenEtPExt2,
  } = useOpen();

  const etiquetasPanelExteriorPhoto2 = useWorkflowStore(
    (state) => state.etiquetasPanelExteriorPhoto2
  );

  const setEtiquetasPanelExteriorPhoto2 = useWorkflowStore(
    (state) => state.setEtiquetasPanelExteriorPhoto2
  );
  const fotoUrl = useBlobUrl(etiquetasPanelExteriorPhoto2);

  return (
    <Grid item xs={5} sx={{ m: 1 }}>
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseEtPExt2}
        handleOpen={handleOpenEtPExt2}
        label="LADO DERECHO"
        open={openEtPExt2}
        setFoto={setEtiquetasPanelExteriorPhoto2}
        width={widthFull === "xs" ? 50 : 130}
        fontSize={widthFull === "xs" ? 8 : 10}
      />
    </Grid>
  );
};

const EtiquetaPanelInterior1 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openEtPInt1,
    handleClose: handleCloseEtPInt1,
    handleOpen: handleOpenEtPInt1,
  } = useOpen();

  const etiquetasPanelInteriorPhoto1 = useWorkflowStore(
    (state) => state.etiquetasPanelInteriorPhoto1
  );

  const setEtiquetasPanelInteriorPhoto1 = useWorkflowStore(
    (state) => state.setEtiquetasPanelInteriorPhoto1
  );
  const fotoUrl = useBlobUrl(etiquetasPanelInteriorPhoto1);
  return (
    <Grid item xs={5} sx={{ m: 1 }}>
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseEtPInt1}
        handleOpen={handleOpenEtPInt1}
        label="LADO IZQUIERDO"
        open={openEtPInt1}
        setFoto={setEtiquetasPanelInteriorPhoto1}
        width={widthFull === "xs" ? 50 : 130}
        fontSize={widthFull === "xs" ? 8 : 10}
      />
    </Grid>
  );
};

const EtiquetaPanelInterior2 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openEtPInt2,
    handleClose: handleCloseEtPInt2,
    handleOpen: handleOpenEtPInt2,
  } = useOpen();

  const etiquetasPanelInteriorPhoto2 = useWorkflowStore(
    (state) => state.etiquetasPanelInteriorPhoto2
  );
  const setEtiquetasPanelInteriorPhoto2 = useWorkflowStore(
    (state) => state.setEtiquetasPanelInteriorPhoto2
  );
  const fotoUrl = useBlobUrl(etiquetasPanelInteriorPhoto2);

  return (
    <Grid item xs={5} sx={{ m: 1 }}>
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseEtPInt2}
        handleOpen={handleOpenEtPInt2}
        label="CENTRO"
        open={openEtPInt2}
        setFoto={setEtiquetasPanelInteriorPhoto2}
        width={widthFull === "xs" ? 50 : 130}
        fontSize={widthFull === "xs" ? 8 : 10}
      />
    </Grid>
  );
};

const EtiquetaPanelInterior3 = ({ widthFull }: { widthFull: string }) => {
  const {
    open: openEtPInt3,
    handleClose: handleCloseEtPInt3,
    handleOpen: handleOpenEtPInt3,
  } = useOpen();

  const etiquetasPanelInteriorPhoto3 = useWorkflowStore(
    (state) => state.etiquetasPanelInteriorPhoto3
  );

  const setEtiquetasPanelInteriorPhoto3 = useWorkflowStore(
    (state) => state.setEtiquetasPanelInteriorPhoto3
  );
  const fotoUrl = useBlobUrl(etiquetasPanelInteriorPhoto3);

  return (
    <Grid item xs={5} sx={{ m: 1 }}>
      <OnlyPhoto
        foto={fotoUrl}
        handleClose={handleCloseEtPInt3}
        handleOpen={handleOpenEtPInt3}
        label="LADO DERECHO"
        open={openEtPInt3}
        setFoto={setEtiquetasPanelInteriorPhoto3}
        width={widthFull === "xs" ? 50 : 130}
        fontSize={widthFull === "xs" ? 8 : 10}
      />
    </Grid>
  );
};
